import { discount } from './modules/discount'
import {recoveryRules} from './modules/recoveryRules'
const SaleLayOut = () => import(/*webpackChunkName:'sale'*/'@/page/sale/saleLayOut.vue')
export const sale={
    path:'/sale',
    component:SaleLayOut,
    redirect:'/main/discount/posList',
    children:[
        discount,
        recoveryRules
    ]
}